import { Box, Typography } from "@mui/material";
import { numberFormatter } from "../../utils/numberFormatter";
import "../../assets/css/Text-General.css";

interface SectionItem {
  label: string;
  value: string | number | null | undefined;
  link?: string;
}

interface SectionProps {
  title: string;
  items: SectionItem[];
}

const cardShellSx = {
  flex: 1,
  minWidth: 0,
  backgroundColor: "#ffffff",
  p: 3,
  borderRadius: "12px",
  border: "1px solid #e5e7eb",
  boxShadow:
    "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)",
  mb: 1,
} as const;

const titleRowSx = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  mb: 2.75,
} as const;

export const InfoSection = ({ title, items }: SectionProps) => (
  <Box sx={cardShellSx}>
    <Box sx={titleRowSx}>
      <Typography
          component="h3"
          className="text-general-section-title"
        >
          {title}
        </Typography>
      </Box>
      <Box
        sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 0.25 }}
      >
        {items.map(({ label, value, link }) => (
          <Box
            key={label}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 2,
              minWidth: 0,
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
                paddingRight: label ? 2 : 0,
                flex: "0 0 auto",
                maxWidth: "60%",
                color: "#6b7280 !important",
              }}
            >
              {label}
            </Typography>
            <Typography
              sx={{
                textAlign: label ? "right" : "left",
                wordWrap: "break-word",
                overflowWrap: "break-word",
                flex: "1 1 auto",
                minWidth: 0,
                fontSize: "0.8125rem",
                color: "#0f172a",
              }}
            >
              {value == null ? (
                "-"
              ) : link ? (
                <a
                  href={link}
                  style={{ color: "#1B7A63", textDecoration: "underline" }}
                >
                  {typeof value === "number" ? numberFormatter({ value }) : value}
                </a>
              ) : typeof value === "number" ? (
                numberFormatter({ value })
              ) : (
                value
              )}
            </Typography>
          </Box>
        ))}
      </Box>
  </Box>
);
